import { OrganizationName } from "./name/organization-name";
import { OrganizationOffice } from "./office/organization-office";
import { OrganizationType } from "./type/organization-type";
import { OrganizationStaff } from "./staff/organization-staff";
import { OrganizationActualStaff } from "./actual-staff/organization-actual-staff";
import { OrganizationManager } from "./manager/organization-manager";

/**
 * Поля подразделения, каждое своим компонентом: показ поля решается один раз здесь, а
 * не на каждой странице заново. Все подкомпоненты принимают сущность целиком —
 * `<Organization.Office data={organization} />`, — поэтому вызывающему не нужно знать,
 * из какого вложенного поля собирается значение.
 */
export const Organization = {
  Name: OrganizationName,
  Office: OrganizationOffice,
  Type: OrganizationType,
  Staff: OrganizationStaff,
  ActualStaff: OrganizationActualStaff,
  Manager: OrganizationManager,
};

export { hasOffice } from "./office/has-office";
